/**
 * H8: chapter 2 starter chain (stub) on map 2 (town-b). Four real quests appended after `thousand-swords`
 * (data/quests.ts PLAINS_QUESTS). Counted by systems/ch2Story.ts. TODO-polish: all text is rough skeleton copy
 * (Narrative to rewrite); names are original placeholders.
 */
import type { QuestDef } from '../quests';

export const CH2 = {
  road: 'ch2-road',
  keeper: 'ch2-keeper',
  pocket: 'ch2-pocket',
  duel: 'ch2-duel',
} as const;

export const CH2_CHAIN: readonly string[] = [CH2.road, CH2.keeper, CH2.pocket, CH2.duel];

/** The zone of the chapter and the people the chain puts there (tile coordinates of the 96 m greybox town). */
export const CH2_ZONE = 'town-b';
export const CH2_KEEPER = { name: 'เถ้าแก่ซือหมิง', title: 'ผู้ดูแลเหมือง', sprite: 'stationMaster', at: [48.5, 44.5] } as const; // TODO-polish
export const CH2_FIGHTER = { name: 'ฟางเจิ้น', title: 'นักสู้เหมือง · ท้าประลองได้', sprite: 'guardOfficer', at: [44.5, 54.5] } as const; // TODO-polish
export const CH2_PLACE = 'town-b';

const ELSEWHERE = { name: CH2_KEEPER.name, where: 'ที่ลานกลางเมืองเหมือง' } as const;

export const CH2_QUESTS: readonly QuestDef[] = [
  {
    id: CH2.road,
    title: 'ถนนสายใหม่', // TODO-polish
    offer: 'ถนนทางใต้พาไปยังเมืองเหมืองเงาผา ไปดูเสียหน่อย', // TODO-polish
    remind: 'ไปให้ถึงสถานีม้าปลายถนนทางใต้ แล้วเดินต่อไปเมืองเหมือง', // TODO-polish
    done: 'ถึงเมืองเหมืองเงาผาแล้ว', // TODO-polish
    objectives: [{ type: 'visit', target: CH2_PLACE, count: 1, label: 'ถึงเมืองเหมืองเงาผา' }],
    rewards: { cultivation: 200, gold: 40 },
  },
  {
    id: CH2.keeper,
    title: 'พบผู้ดูแลเหมือง', // TODO-polish
    offer: 'ไปพบเถ้าแก่ซือหมิงที่ลานกลางเมือง', // TODO-polish
    remind: 'เถ้าแก่ซือหมิงอยู่ที่ลานกลางเมือง', // TODO-polish
    done: 'เถ้าแก่ซือหมิงต้อนรับเจ้า', // TODO-polish
    objectives: [{ type: 'talk', target: 'keeper', count: 1, label: 'คุยกับเถ้าแก่ซือหมิง' }],
    rewards: { cultivation: 250, gold: 50 },
    giver: ELSEWHERE,
  },
  {
    id: CH2.pocket,
    title: 'หมาป่าในเหมือง', // TODO-polish
    offer: 'หมาป่าบุกปากเหมืองทางมุมตะวันออกเฉียงใต้ ช่วยกำจัดสามตัว', // TODO-polish
    remind: 'หมาป่าอยู่นอกลาน มุมตะวันออกเฉียงใต้ของเมือง', // TODO-polish
    done: 'ปากเหมืองสงบแล้ว', // TODO-polish
    objectives: [{ type: 'kill', target: 'wolf', count: 3, label: 'หมาป่า' }],
    rewards: { cultivation: 400, gold: 80 },
    giver: ELSEWHERE,
  },
  {
    id: CH2.duel,
    title: 'ประลองกับนักสู้เหมือง', // TODO-polish
    offer: 'ฟางเจิ้นนักสู้ของเหมืองอยากลองฝีมือเจ้า ท้าเขาที่ลานกลางเมือง', // TODO-polish
    remind: 'ท้าประลองฟางเจิ้นที่ลานกลางเมือง', // TODO-polish
    done: 'เจ้าชนะฟางเจิ้นแล้ว', // TODO-polish
    objectives: [{ type: 'duelWin', count: 1, label: 'ชนะประลองฟางเจิ้น' }],
    rewards: { cultivation: 600, gold: 120 },
    giver: { name: CH2_FIGHTER.name, where: 'ที่ลานกลางเมือง' },
  },
];
